import TextContent from '../components/Molecules/TextContent';
import List from '../components/Molecules/List';
import Text from '../components/Atoms/Text';

const elements = [
  {
    title: 'Hier ga je werken',
    subtitle: 'Info over het bedrijf',
    children: (
      <TextContent>
        <Text as="p">Locatie: Zwolle</Text>
        <Text as="p">
          Dit toonaangevende machinebouwbedrijf staat volop
          in ontwikkeling en is sterk groeiend! Met 180 man
          bouwen ze aan een ontzettend leuke
          vooruitstrevende organisatie met unieke machines.
          Ze ontwikkelen state- of the art
          verpakkingsmachines en complete lijnen voor
          verschillende branches. De machines kenmerken zich
          als hightech, mechatronisch en beschikken soms
          over proces technische modules. Het werken aan
          deze machines is dus ontzettend allround en
          dynamisch!Dit toonaangevende machinebouwbedrijf
          staat volop in ontwikkeling en is sterk groeiend!
          Met 180 man bouwen ze aan een ontzettend leuke
          vooruitstrevende organisatie met unieke machines.
          Ze ontwikkelen state- of the art
          verpakkingsmachines en complete lijnen voor
          verschillende branches. De machines kenmerken zich
          als hightech, mechatronisch en beschikken soms
          over proces technische modules. Het werken aan
          deze machines is dus ontzettend allround en
          dynamisch!Dit toonaangevende machinebouwbedrijf
          staat volop in ontwikkeling en is sterk groeiend!
          Met 180 man bouwen ze aan een ontzettend leuke
          vooruitstrevende organisatie met unieke machines.
          Ze ontwikkelen state- of the art
          verpakkingsmachines en complete lijnen voor
          verschillende branches. De machines kenmerken zich
          als hightech, mechatronisch en beschikken soms
          over proces technische modules. Het werken aan
          deze machines is dus ontzettend allround en
          dynamisch!Dit toonaangevende machinebouwbedrijf
          staat volop in ontwikkeling en is sterk groeiend!
          Met 180 man bouwen ze aan een ontzettend leuke
          vooruitstrevende organisatie met unieke machines.
          Ze ontwikkelen state- of the art
          verpakkingsmachines en complete lijnen voor
          verschillende branches. De machines kenmerken zich
          als hightech, mechatronisch en beschikken soms
          over proces technische modules. Het werken aan
          deze machines is dus ontzettend allround en
          dynamisch!Dit toonaangevende machinebouwbedrijf
          staat volop in ontwikkeling en is sterk groeiend!
          Met 180 man bouwen ze aan een ontzettend leuke
          vooruitstrevende organisatie met unieke machines.
          Ze ontwikkelen state- of the art
          verpakkingsmachines en complete lijnen voor
          verschillende branches. De machines kenmerken zich
          als hightech, mechatronisch en beschikken soms
          over proces technische modules. Het werken aan
          deze machines is dus ontzettend allround en
          dynamisch!Dit toonaangevende machinebouwbedrijf
          staat volop in ontwikkeling en is sterk groeiend!
          Met 180 man bouwen ze aan een ontzettend leuke
          vooruitstrevende organisatie met unieke machines.
          Ze ontwikkelen state- of the art
          verpakkingsmachines en complete lijnen voor
          verschillende branches. De machines kenmerken zich
          als hightech, mechatronisch en beschikken soms
          over proces technische modules. Het werken aan
          deze machines is dus ontzettend allround en
          dynamisch!Dit toonaangevende machinebouwbedrijf
          staat volop in ontwikkeling en is sterk groeiend!
          Met 180 man bouwen ze aan een ontzettend leuke
          vooruitstrevende organisatie met unieke machines.
          Ze ontwikkelen state- of the art
          verpakkingsmachines en complete lijnen voor
          verschillende branches. De machines kenmerken zich
          als hightech, mechatronisch en beschikken soms
          over proces technische modules. Het werken aan
          deze machines is dus ontzettend allround en
          dynamisch!
        </Text>
        <Text as="p">
          De sfeer is ontzettend goed in dit bedrijf; er
          zijn korte communicatielijnen en er wordt echt
          samengewerkt. Het management vindt het belangrijk
          dat het werk leuk is, je flexibel bent en kennis
          hebt om verschillende posities op te kunnen
          vullen. Daarnaast staat je persoonlijke
          ontwikkeling en die van de machines centraal. Dit
          is een hele leuke werkgever om voor te werken en
          ze zoeken hard naar nieuwe medewerkers die willen
          bijdragen aan mooie resultaten!
        </Text>
      </TextContent>
    )
  },
  {
    title: 'Dit vind je leuk om te doen',
    subtitle: 'Functie-inhoud',
    children: (
      <List
        listItems={[
          'het oplossen van complexe problemen en storingen aan de machines wereldwijd bij de klant op locatie',
          'het plegen van gepland onderhoud aan de machines',
          'incidenteel zal het plaatsen en in bedrijf stellen van de machines onderdeel zijn van het takenpakket van de Field Service Engineer',
          'het gebruik gereed installeren en opleveren van de machines',
          'als Field Service Engineer instrueer je de klant over het gebruik en operationeel onderhoud van de machines'
        ]}
        color="blue"
        icon="checkmark"
      />
    )
  },
  {
    title: 'Hier herken jij jezelf in',
    subtitle: 'Functie-eisen',
    children: (
      <List
        listItems={[
          'Je hebt minimaal een MBO-diploma niveau 4 in de richting van Elektrotechniek, Werktuigbouwkunde of Mechatronica',
          'Je bent bereid om enkele weken aaneengesloten van huis te zijn, het huidige reisritme is circa 70% waarbij je twee á drie weken op locatie bent en één week thuis (twee weekenden weg, twee weekenden thuis)',
          'Je hebt een goede beheersing van de Nederlandse en Engelse taal, zowel in woord als geschrift',
          'Je hebt enkele jaren werkervaring in een soortgelijke functie als (Internationaal) Field Service Engineer of Commissioning Engineer',
          'Kennis van PLC’s is een pré voor het uitlezen van storingen',
          'Je omschrijft jezelf als zelfstandig, pro-actief, gedreven en flexibel'
        ]}
        color="blue"
        icon="checkmark"
      />
    )
  }
];

export default elements;
